import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestfulApiService } from '../restful-api.service';
import { InviteUserPayload, CharitySearchResult, InviteUserErrorResponse, InviteEmailCheckResult } from '../../models/admin';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  constructor(private apiService: RestfulApiService) {}

  /**
   * Search for charities/organizations by name
   * @param query Search query string
   * @returns Observable of charity search results
   */
  searchCharities(query: string): Observable<{ response: CharitySearchResult[] }> {
    return this.apiService.get('/v1/admin/entities/ORGANISATION', { searchInput: query }) as Observable<{ response: CharitySearchResult[] }>;
  }

  /**
   * Invite users to the platform
   * @param payload Array of user invitation payloads
   * @returns Observable of the API response containing status for each user
   */
  inviteUsers(payload: InviteUserPayload[]): Observable<InviteUserErrorResponse> {
    return this.apiService.post('/v1/admin/invite-user', payload) as Observable<InviteUserErrorResponse>;
  }

  /**
   * Check whether an email already matches an existing GivingSpace user in this tenant
   * @param email Email address to check
   * @returns Observable of the match result (response is null when there's no match)
   */
  checkExistingUser(email: string): Observable<{ response: InviteEmailCheckResult | null }> {
    return this.apiService.get('/v1/admin/check-name', { email }) as Observable<{ response: InviteEmailCheckResult | null }>;
  }
}
